var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_556_211445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0233 9.71726C12.8019 9.42865 14.0097 7.75288 13.7211 5.97431C13.4325 4.19575 11.7568 2.9879 9.97819 3.2765C8.19962 3.56511 6.99177 5.24088 7.28038 7.01945C7.56899 8.79801 9.24476 10.0059 11.0233 9.71726Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37109 14.2734C3.37109 16.2 4.93673 17.7656 6.86329 17.7656H14.1383C16.0649 17.7656 17.6305 16.2 17.6305 14.2734C17.6305 12.3469 16.0648 10.7812 14.1383 10.7812H6.86329C4.93673 10.7812 3.37109 12.3469 3.37109 14.2734Z",
    fill: "#637381"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_556_211445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.686824f1de5acc26411c3d14507c1c18.svg";
export { ForwardRef as ReactComponent };